import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Nav } from 'react-bootstrap';

export function Pager(props) {
 
    const handlePageSizeChange = (event) => {
        let newPageSize = event.target.value * 1;
        props.onPageSizeChange(props.page, newPageSize);
    }

    const handlePageChange = (event) => {
        if (event.target.validity.valid) {
            changePage(event.target.value * 1);
        }
    }

    const handlePreviousPage = () => {
        changePage(props.page - 1);
    }

    const handleNextPage = () => {
        changePage(props.page + 1);
    }

    const changePage = (page) => {
        let newPage = getValidPageValue(page);
        props.onPageChange(newPage, props.pageSize);
    }

    const getValidPageValue = (pageValue) => {
        return clamp(1, pageValue, props.maxPages)
    }

    const clamp = (min, value, max) => {
        return Math.max(Math.min(max, value), min);
    }

    return (
        <Nav aria-label="Page navigation row">
            <Col xs={6} sm={3} className="form-group text-start">
                <label className="inline">Go to page:</label> 
                <Form.Select onChange={handlePageChange} value={props.page} className="form-control page-select">
                    {Array(props.maxPages)
                        .fill()
                        .map((_, i) => <option value={i + 1} key={i}>{i + 1}</option>)}
                </Form.Select>
            </Col>
            <Col xs={6} sm={3} className="form-group text-end">
                <label className="inline">Rows per page:</label>
                <Form.Select onChange={handlePageSizeChange} value={props.pageSize} className="form-control page-select">
                    {props.pageSizeOptions.map(s => <option value={s} key={s}>{s}</option>)}
                </Form.Select>
            </Col>
            <Col xs={6} sm={3} className="hidden-xs pagination-counts text-end">
                <span className="current-page">{(props.page - 1) * props.pageSize + 1} - {Math.min(props.page * props.pageSize, props.maxItems)}</span> of <span className="total-count">{props.maxItems}</span>
            </Col>
            <Col xs={6} sm={3}>
                <ul className="pagination">
                    <li>
                        <button onClick={handleNextPage} hidden={props.page === props.maxPages}>&gt;</button>
                    </li>
                    <li>
                        <button onClick={handlePreviousPage} hidden={props.page === 1}>&lt;</button>
                    </li>
                </ul>
            </Col>
        </Nav>
    );
}

Pager.propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    maxPages: PropTypes.number.isRequired,
    maxItems: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    pageSizeOptions: PropTypes.array
}

Pager.defaultProps = {
    pageSizeOptions: [10, 25, 50]
}